import { Link } from "react-router-dom";
import NewsCard from "@/components/base/NewsCard";
import SectionHeading from "@/components/base/SectionHeading";
import { newsList } from "@/mocks/news";

export default function NewsSection() {
  const list = newsList.slice(0, 5);

  return (
    <section className="w-full bg-background-100 px-4 md:px-8 py-12 md:py-16">
      <SectionHeading
        title="影视资讯快递"
        subtitle="行业动态、深度观察与影人访谈，了解国产影视最新风向"
        morePath="/news"
        moreLabel="查看更多资讯"
      />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
        <div className="flex flex-col gap-4">
          {list.slice(0, 3).map((article) => (
            <NewsCard key={article.id} article={article} layout="list" />
          ))}
        </div>
        <div className="flex flex-col gap-4">
          {list.slice(3, 5).map((article) => (
            <NewsCard key={article.id} article={article} layout="list" />
          ))}
          <Link
            to="/news"
            className="flex items-center justify-between p-4 rounded-lg bg-primary-50 border border-primary-100 hover:border-primary-300 transition-colors"
          >
            <div>
              <p className="font-heading text-base font-semibold text-primary-700">
                资讯专题中心
              </p>
              <p className="mt-1 text-xs text-foreground-600">
                汇聚影视动态、行业深度与明星访谈
              </p>
            </div>
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shrink-0">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}